import React, { useEffect, useState } from 'react';
// Import necessary components from react-router-dom
import { fetchAuthSession, signOut } from 'aws-amplify/auth'; // Import signOut and fetchAuthSession from Amplify Auth
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
// Import logging service
import loggingService from './services/loggingService';
import { bootstrapCometchatSession } from './services/cometchatSession';

// Corrected import paths for your components
import HomePage from './HomePage'; // Re-import HomePage, assuming it's a layout component
import Authorization from './components/Authorization/Authorization';
import BillCustomerView from './components/BillCustomer/BillCustomerView'; // <--- ADDED: Import BillCustomerView component
import BillCustomer from './components/BillCustomer/Bill_Customer'; // <--- ADDED: Import BillCustomer component
import Dashboard from './components/Dashboard/Dashboard'; // Assuming Dashboard is your main authenticated view
import LiveRidesDashboard from './components/Dashboard/LiveRidesDashboard'; // Import new LiveRidesDashboard component
import LiveVehicleDashboard from './components/LiveVehicleLocation/LiveVehicleDashboard';
import PatrollingDashboard from './components/Dashboard/Patrolling/PatrollingDashboard'; // Import PatrollingDashboard component
import EstimationQuotation from './components/EstimationQuotation/Estimation_Quotation'; // <--- ADDED: Import EstimationQuotation component
import QuotationView from './components/EstimationQuotation/QuotationView'; // <--- ADDED: Import QuotationView component
import InteriorQuotation from './components/InteriorQuotation/InteriorQuation'; // <--- ADDED: Import InteriorQuotation component
import CreateInteriorQuatation from './components/InteriorQuotation/CreateInteriorQuatation'; // <--- ADDED: Import CreateInteriorQuatation component
import QuotationFilePreview from './components/InteriorQuotation/QuotationFilePreview';
import InventoryDataLogsTable from './components/Inventory/InventoryDataLogsTable'; // <--- ADDED: Import InventoryDataLogsTable component
import InventoryItemDetail from './components/Inventory/InventoryItemDetail'; // <--- ADDED: Import InventoryItemDetail component
import ItemMaintenance from './components/Inventory/ItemMaintenance'; // <--- ADDED: Import ItemMaintenance component
import ManageInventory from './components/Inventory/ManageInventory'; // <--- ADDED: Import ManageInventory component
import ReturnMaintenance from './components/Inventory/ReturnMaintenance'; // <--- ADDED: Import ReturnMaintenance component
import CreateInvoice from './components/Invoice/Create_Invoice'; // <--- ADDED: Import CreateInvoice component
import InvoiceView from './components/Invoice/InvoiceView'; // <--- ADDED: Import InvoiceView component
import { LeaveManagement } from './components/LeaveManagement'; // <--- ADDED: Import LeaveManagement component
import Assigned from './components/OfficerStatus/Assigned'; // Imported Assigned component
import NotAssigned from './components/OfficerStatus/NotAssigned'; // Imported NotAssigned component
import BulkOnboarding from './components/Onboarding/BulkOnboarding'; // <--- ADDED: Import BulkOnboarding component
import CloseStockView from './components/Onboarding/ClosingStock/CloseStockView.js'; // <--- ADDED: Import CloseStockView component
import Closing_Stock from './components/Onboarding/ClosingStock/Closing_Stock.js'; // <--- ADDED: Import Closing_Stock component
import CreateClosingStocks from './components/Onboarding/ClosingStock/CreateClosingStocks.js'; // <--- ADDED: Import CreateClosingStocks component
import CustomerListView from './components/Onboarding/CustomerOnboarding/CustomerListView';
import CustomerOnboarding from './components/Onboarding/CustomerOnboarding/Customer_Onboarding';
import InventoryItemOnboarding from './components/Onboarding/InventoryItemOnboarding'; // <--- ADDED: Import InventoryItemOnboarding component
import StockInView from './components/Onboarding/Stock_in/StockInView'; // <--- ADDED: Import StockInView component
import Stock_in from './components/Onboarding/Stock_in/Stock_in'; // <--- ADDED: Import Stock_in component
import StockOnboarding from './components/Onboarding/Stock_in/Stock_onboarding'; // <--- ADDED: Import StockOnboarding component
import UserOnboarding from './components/Onboarding/UserOnboarding'; // <--- ADDED: Import UserOnboarding component
import VehicleOnboarding from './components/Onboarding/VehicleOnboarding'; // <--- ADDED: Import VehicleOnboarding component
import OrgChartHierarchy from './components/OrgChart/OrgChartHierarchy'; // Import OrgCharthierarchy
import DeleteEmployeeProfile from './components/OrgManagement/DeleteEmployeeProfile';
import ProductTemplateView from './components/Product/ProductTemplateView'; // <--- ADDED: Import ProductTemplateView component
import ProductTemplate from './components/Product/Product_template'; // <--- ADDED: Import ProductTemplate component
import Production from './components/Production/Production'; // <--- ADDED: Import Production component
import ProductionView from './components/Production/ProductionView'; // <--- ADDED: Import ProductionView component
import PurchaseOrderView from './components/PurchaseOrder/PurchaseOrderView'; // <--- ADDED: Import PurchaseOrderView component
import PurchaseOrder from './components/PurchaseOrder/Purchase_Order.js'; // <--- ADDED: Import PurchaseOrder component
import { FeedbackAnalytics, ServiceRecovery } from './components/ServiceRecovery'; // <--- ADDED: Import ServiceRecovery and FeedbackAnalytics
import StockOutDetails from './components/StockOut/StockOutDetails'; // <--- ADDED: Import StockOutDetails component
import StockOutView from './components/StockOut/StockOutView'; // <--- ADDED: Import StockOutView component
import Stock_out from './components/StockOut/Stock_out'; // <--- ADDED: Import Stock_out component
import Fdoc from './components/Tax/Fdoc'; // <--- ADDED: Import Fdoc component
import TaxOverView from './components/Tax/TaxOverView'; // <--- ADDED: Import TaxOverView component
import VendorOnboarding from './components/Vender/Vender_Onboarding';
import VendorListView from './components/Vender/VendorListView';
import WasteLoggingView from './components/WasteLogging/WasteLoggingView'; // <--- ADDED: Import WasteLoggingView component
import WasteLogging from './components/WasteLogging/Waste_Logging'; // <--- ADDED: Import WasteLogging component
// import SupervisorTransferDelete from './components/OrgManagement/baserole_supervisor_transfer_delete_conformation';

import AnalyticsDashboard from './components/Analytics/AnalyticsDashboard'; // <--- ADDED: Import AnalyticsDashboard component
import { ApprovalWorkflow } from './components/ApprovalWorkflow';
import BestPerformer from './components/BestPerformer/BestPerformer'; // <--- ADDED: Import BestPerformer component
import SafeDropForm from './components/CashSettlement/SafeDropForm'; // <--- ADDED: Import SafeDropForm component
import ShiftSettlementSummary from './components/CashSettlement/ShiftSettlementSummary';
import CameraAttendanceOverstayScreen from './components/CameraAttendance/CameraAttendanceOverstayScreen';
import CameraAttendanceAllFeedsScreen from './components/CameraAttendance/CameraAttendanceAllFeedsScreen';
import CameraAttendanceScreen from './components/CameraAttendance/CameraAttendanceScreen';
import LiveViewScreen from './components/VideoAttendance/LiveViewScreen';
import ZoneDesignerScreen from './components/VideoAttendance/ZoneDesignerScreen';
import ZonesHomeScreen from './components/VideoAttendance/ZonesHomeScreen';
import CentralKitchen from './components/CentralKitchen/CentralKitchen'; // Central kitchen inter-outlet planner
import BusinessAnalytics from './components/Dashboard/Business/BusinessAnalytics';
import ChefAnalytics from './components/Dashboard/ChefAndDishAnalytics/ChefAnalytics';
import Inventory_Dashboard from './components/Dashboard/Inventory/Inventory_Dashboard'; // <--- ADDED: Import Inventory_Dashboard component
import RestorantSiteAnalytics from './components/Dashboard/RestorantSites/RestorantSiteAnalytics.js';
import SalesAnalytics from './components/Dashboard/Sales/SalesAnalytics'; // <--- ADDED: Import SalesAnalytics component
import AllStockItems from './components/Dashboard/StockDashboard/AllStockIteams'; // <--- ADDED: Import AllStockItems component
import StockDashboard from './components/Dashboard/StockDashboard/StockDashboard'; // <--- ADDED: Import StockDashboard component
import WastageDashboard from './components/Dashboard/Wastage/WastageDashboard'; // <--- ADDED: Import WastageDashboard component
import DynamicDemandPricingScreen from './components/DynamicPricing/DynamicDemandPricingScreen'; // Dynamic demand-based pricing dashboard
import PricingRulesScreen from './components/DynamicPricing/PricingRulesScreen'; // Pricing rules list/detail + signals
import { FacilityBooking, FacilityBookingBillCustomer, FacilityBookingInvoice } from './components/FacilityBooking'; // <--- ADDED: Import FacilityBooking components
import HyperLocalReferralTracker from './components/HyperLocalReferralTracker/HyperLocalReferralTracker';
import InfluencerReferralDashboard from './components/HyperLocalReferralTracker/InfluencerReferralDashboard';
import IssuesAndTasksDashboard from './components/IAndT/IssuesAndTasksDashboard'; // <--- ADDED: Import IssuesAndTasksDashboard component
import DelayAnalysisZoomed from './components/IAndT/ZoomedViews/DelayAnalysisZoomed';
import IssuesRaisedSolvedZoomed from './components/IAndT/ZoomedViews/IssuesRaisedSolvedZoomed';
import PendingIssuesZoomed from './components/IAndT/ZoomedViews/PendingIssuesZoomed'; // Import zoomed views
import TrackIssueCompletionZoomed from './components/IAndT/ZoomedViews/TrackIssueCompletionZoomed';
import UtilityAlertsPanel from './components/InvisibleCostTracker/UtilityAlertsPanel';
import UtilityLogForm from './components/InvisibleCostTracker/UtilityLogForm';
import UtilityMatrixDashboard from './components/InvisibleCostTracker/UtilityMatrixDashboard';
import KitchenDisplayScreen from './components/KitchenDisplay/KitchenDisplayScreen';
import LaborForecastHeatmap from './components/LaborForcast/LaborForecastHeatmap.js'; // Labor Forecast heatmap
import LiveOrderFeedScreen from './components/LiveOrderFeed/LiveOrderFeedScreen';
import OrderDetsilsScreen from './components/OrderDetails/OrderDetsilsScreen';
import OrderHistoryScreen from './components/OrderHistory/OrderHistoryScreen';
import ScheduleAPatrole from './components/Patrolling/ScheduleAPatrole'; // <--- ADDED: Import ScheduleAPatrole component
import LostAndFound from './components/LostAndFound/LostAndFound';
import CreateLostAndFound from './components/LostAndFound/CreateLostAndFound';
import LostAndFoundDetail from './components/LostAndFound/LostAndFoundDetail';
import CollectLostAndFoundItem from './components/LostAndFound/CollectLostAndFoundItem';
import QRManagement from './components/QR/QRManagement';
import CreateQR from './components/QR/CreateQR';
import PlaceOrderScreen from './components/PlaceOrder/PlaceOrderScreen';
import PlatformSettingScreen from './components/PlatformSettings/PlatformSettingScreen';
import Profile from './components/Profile/Profile'; // Your Profile component
import EmployeeReport from './components/Reports/EmployeeReport'; // Imported EmployeeReport component
import FieldOfficerReport from './components/Reports/FieldOfficerReport'; // <--- ADDED: Import FieldOfficerReport component
import LiveVehicleReport from './components/Reports/LiveVehicleReport';
import RideReports from './components/Reports/RideReports'; // Imported RideReports component
import SiteReports from './components/Reports/SiteReports'; // Imported SiteReports component
import ScheduleCalendar from './components/Schedule/ScheduleCalendar'; // <--- ADDED: Import ScheduleCalendar component
import ScheduleARide from './components/ScheduleARide/Schedule_A_Ride'; // <--- ADDED: Import ScheduleARide component
import ScheduleACleaning from './components/CleaningSchedule/ScheduleACleaning';
import ScheduleShift from './components/ShiftManagement/ScheduleAShift'; // Imported ScheduleShift component
import ShiftPermissionManagement from './components/ShiftPermissionManagement/ShiftPermissionManagement'; // <--- ADDED: Import ShiftPermissionManagement component
import SiteManagement from './components/SiteManagement/SiteManagement'; // <--- ADDED: Import SiteManagement component
import ChatGroupManagement from './components/SiteManagement/ChatGroupManagement/ChatGroupManagement';
import CreateGroup from './components/SiteManagement/ChatGroupManagement/CreateGroup';
import ChatGroupPageWrapper from './components/SiteManagement/ChatGroupManagement/ChatGroupPageWrapper';
import SmartAutoRecorder from './components/SmartAuto/SmartAutoRecorder'; // Auto-86 / Menu availability
import FloorPlanDesigner from './components/TableBooking/FloorPlaning/FloorPlanDesigner.js'; // <--- ADDED: Import FloorPlanDesigner component
import OnboardTable from './components/TableBooking/OnboardTables/OnboardTable';
import BookingBoard from './components/TableBooking/TableBooking/BookingBoard.js'; // <--- ADDED: Import BookingBoard component
import WaitlistPanel from './components/TableBooking/WaitlistPanel'; // <--- ADDED: Import WaitlistPanel component
import CameraAttendanceLogsScreen from './components/CameraAttendance/CameraAttendanceLogsScreen';
import CommunityDuesTable from './components/Dues/CommunityDuesTable';
import CreateDue from './components/Dues/CreateDue';
import DueDetail from './components/Dues/DueDetail';
import ProjectsList from './components/Projects/ProjectsList';
import CreateProject from './components/Projects/CreateProject';
import ProjectScopePreview from './components/Projects/ProjectScopePreview';

// A generic placeholder component for undeveloped pages
const PlaceholderPage = ({ pageTitle }) => (
  <div className="flex items-center justify-center h-full text-center text-xl text-gray-400">
    <p>Content for &quot;{pageTitle}&quot; is not yet developed.</p>
  </div>
);

// Route Tracker Component - Tracks route changes for logging
const RouteTracker = ({ isAuthenticated }) => {
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      // Update current screen/route in logging service
      const route = location.pathname;
      const screenName = route.split('/').pop() || 'home';
      loggingService.setCurrentScreen(screenName, route);
    }
  }, [location, isAuthenticated]);

  return null;
};

// Protected Route Component
const ProtectedRoute = ({ children, isAuthenticated, loadingAuth }) => {
  console.log('🛡️ ProtectedRoute check:', { isAuthenticated, loadingAuth });

  if (loadingAuth) {
    console.log('⏳ Still loading auth, showing loading screen');
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <p className="text-xl text-gray-700">Loading application...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('🚫 User not authenticated, redirecting to login');
    return <Navigate to="/" replace />;
  }

  console.log('✅ User authenticated, rendering protected content');
  return children;
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(true); // State to manage initial auth loading

  // Check authentication status on app load and initialize logging
  useEffect(() => {
    const checkAuthStatus = async () => {
      console.log('🔍 Checking authentication status...');

      // Clear any stored authentication data to ensure clean state
      try {
        localStorage.removeItem('amplify-authenticator-authToken');
        sessionStorage.clear();
        console.log('🧹 Cleared stored authentication data');
      } catch (e) {
        console.log('⚠️ Could not clear storage:', e);
      }

      try {
        const { tokens } = await fetchAuthSession();
        console.log(
          '📋 Fetched auth session:',
          tokens ? 'Tokens found' : 'No tokens'
        );

        // More robust authentication check
        if (tokens && tokens.idToken) {
          const idToken = tokens.idToken;
          const currentTime = Math.floor(Date.now() / 1000);
          console.log('🔑 ID Token found, checking expiration...');
          console.log(
            '⏰ Token expires at:',
            new Date(idToken.payload.exp * 1000).toISOString()
          );
          console.log(
            '⏰ Current time:',
            new Date(currentTime * 1000).toISOString()
          );

          // Check if token is valid and not expired
          if (idToken.payload.exp > currentTime) {
            console.log('✅ Valid authentication session found');
            setIsAuthenticated(true);

            // Initialize logging service
            try {
              const payload = idToken.payload;
              const userId = payload.sub || payload['cognito:username'];
              const tenantId =
                payload['custom:tenant_id'] || payload.tenant_id || null;
              const vertical =
                payload['custom:business_vertical'] ||
                payload['business_vertical'] ||
                payload.vertical ||
                'core';

              await loggingService.initialize(userId, tenantId, vertical);

              // Set initial screen
              const initialRoute = window.location.pathname;
              const initialScreen =
                initialRoute.split('/').pop() || 'home';
              loggingService.setCurrentScreen(initialScreen, initialRoute);

              // Log app initialization
              // Note: userId, tenantId, and vertical are already included at top level
              await loggingService.logInfo('app_init', 'Application initialized');

              bootstrapCometchatSession().catch(bootstrapError => {
                console.warn('CometChat bootstrap skipped:', bootstrapError);
              });
            } catch (logError) {
              console.error('Error initializing logging service:', logError);
            }
          } else {
            console.log('❌ Token expired, user needs to re-authenticate');
            setIsAuthenticated(false);
          }
        } else {
          console.log('❌ No valid tokens found');
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.log('❌ User not authenticated:', error);
        setIsAuthenticated(false);
      } finally {
        console.log(
          '🏁 Authentication check complete. isAuthenticated:',
          isAuthenticated
        );
        setLoadingAuth(false); // Auth check is complete
      }
    };
    checkAuthStatus();
  }, []);

  const handleAuthSuccess = async () => {
    setIsAuthenticated(true);
    console.log('Authentication successful! Navigating to the dashboard.');

    // Initialize logging service after successful authentication
    try {
      const { tokens } = await fetchAuthSession();
      if (tokens && tokens.idToken) {
        const payload = tokens.idToken.payload;
        const userId = payload.sub || payload['cognito:username'];
        const tenantId =
          payload['custom:tenant_id'] || payload.tenant_id || null;
        const vertical =
          payload['custom:business_vertical'] ||
          payload['business_vertical'] ||
          payload.vertical ||
          'core';

        await loggingService.initialize(userId, tenantId, vertical);

        // Set initial screen
        const initialRoute = window.location.pathname;
        const initialScreen = initialRoute.split('/').pop() || 'home';
        loggingService.setCurrentScreen(initialScreen, initialRoute);

        // Log successful authentication
        // Note: userId and tenantId are already included at top level
        await loggingService.logInfo('auth_success', 'User authenticated successfully');

        bootstrapCometchatSession().catch(bootstrapError => {
          console.warn('CometChat bootstrap skipped:', bootstrapError);
        });
      }
    } catch (logError) {
      console.error('Error initializing logging service:', logError);
    }
  };

  // Centralized logout function for Cognito
  const handleLogout = async () => {
    try {
      // Log logout event before signing out
      try {
        await loggingService.logInfo('auth_logout', 'User logging out');
        await loggingService.forceFlush(); // Flush logs before logout
      } catch (logError) {
        console.error('Error logging logout event:', logError);
      }

      await signOut(); // Call Amplify signOut
      setIsAuthenticated(false); // Update authentication state

      // Clear logging service state
      loggingService.clearLogs();
      loggingService.stopPeriodicFlush();

      console.log('User signed out successfully from Cognito.');
    } catch (error) {
      console.error('Error signing out from Cognito:', error);
      // Log error
      try {
        await loggingService.logError('auth_logout_error', 'Error during logout', error);
      } catch (logError) {
        // Ignore logging errors during logout
      }
    }
  };

  // Debug information in development
  if (process.env.NODE_ENV === 'development') {
    console.log('Current authentication state:', {
      isAuthenticated,
      loadingAuth,
    });
  }

  return (
    <Router>
      <AppContent
        isAuthenticated={isAuthenticated}
        loadingAuth={loadingAuth}
        onAuthSuccess={handleAuthSuccess}
        onLogout={handleLogout}
      />
    </Router>
  );
};

// App Content Component - Wraps Routes and RouteTracker
const AppContent = ({
  isAuthenticated,
  loadingAuth,
  onAuthSuccess,
  onLogout,
}) => {
  return (
    <>
      <RouteTracker isAuthenticated={isAuthenticated} />
      <Routes>
        {/* Public Route: Login page */}
        <Route
          path="/"
          element={(() => {
            console.log('🏠 Root route check:', {
              isAuthenticated,
              loadingAuth,
            });
            if (isAuthenticated) {
              console.log(
                '🔄 User authenticated, redirecting to dashboard analytics'
              );
              return <Navigate to="/dashboard-analytics" replace />;
            } else {
              console.log('📝 User not authenticated, showing login page');
              return (
                <Authorization
                  onAuthSuccess={onAuthSuccess}
                  onLogoutSuccess={onLogout}
                />
              );
            }
          })()}
        />

        {/* Dashboard Route - Only Dashboard component under /dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          {/* Main Dashboard route - only Dashboard component here */}
          <Route
            index
            element={<Dashboard isAuthenticated={isAuthenticated} />}
          />
        </Route>

        {/* Dashboard Sub-routes */}
        <Route
          path="/dashboard-analytics"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<AnalyticsDashboard />} />
        </Route>

        <Route
          path="/dashboard-live-rides"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={<LiveRidesDashboard isAuthenticated={isAuthenticated} />}
          />
        </Route>

        <Route
          path="/dashboard-live-vehicle"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LiveVehicleDashboard />} />
        </Route>

        <Route
          path="/dashboard-patrolling"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={<PatrollingDashboard isAuthenticated={isAuthenticated} />}
          />
        </Route>

        <Route
          path="/dashboard-live-order-feed"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LiveOrderFeedScreen />} />
        </Route>

        <Route
          path="/dashboard-order-history"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<OrderHistoryScreen />} />
        </Route>

        <Route
          path="/dashboard-platform-settings"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<PlatformSettingScreen />} />
        </Route>

        <Route
          path="/dashboard-employee-performer"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<BestPerformer />} />
        </Route>

        <Route
          path="/dashboard-inventory"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<Inventory_Dashboard />} />
        </Route>

        <Route
          path="/dashboard-sales-analytics"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<SalesAnalytics />} />
        </Route>

        <Route
          path="/dashboard-business-analytics"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<RestorantSiteAnalytics />} />
        </Route>

        <Route
          path="/business-analytics"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<BusinessAnalytics />} />
        </Route>

        <Route
          path="/chef-analytics"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ChefAnalytics />} />
        </Route>

        <Route
          path="/dashboard-stock-dashboard"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<StockDashboard />} />
        </Route>

        <Route
          path="/dashboard-all-stock-items"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<AllStockItems />} />
        </Route>

        <Route
          path="/dashboard-auto86"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<SmartAutoRecorder />} />
        </Route>

        <Route
          path="/dashboard-pricing-dashboard"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<DynamicDemandPricingScreen />} />
        </Route>

        <Route
          path="/dashboard-pricing-rules"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<PricingRulesScreen />} />
        </Route>

        <Route
          path="/dashboard-wastage-dashboard"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<WastageDashboard />} />
        </Route>

        <Route
          path="/dashboard-central-kitchen"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<CentralKitchen />} />
        </Route>

        <Route
          path="/dashboard-influencer-referral"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<InfluencerReferralDashboard />} />
        </Route>

        <Route
          path="/dashboard-ti-dashboard"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<IssuesAndTasksDashboard />} />
        </Route>

        {/* T&I Dashboard Zoomed Views */}
        <Route
          path="/dashboard-ti-dashboard-zoomed-pending-issues"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<PendingIssuesZoomed />} />
        </Route>

        <Route
          path="/dashboard-ti-dashboard-zoomed-track-issue-completion"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<TrackIssueCompletionZoomed />} />
        </Route>

        <Route
          path="/dashboard-ti-dashboard-zoomed-delay-analysis"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<DelayAnalysisZoomed />} />
        </Route>

        <Route
          path="/dashboard-ti-dashboard-zoomed-issues-raised-solved"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<IssuesRaisedSolvedZoomed />} />
        </Route>

        {/* Other Protected Routes - Each at their own root path */}
        <Route
          path="/camera-attendance"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<CameraAttendanceScreen />} />
          <Route path="logs" element={<CameraAttendanceLogsScreen />} />
          <Route path="all-feeds" element={<CameraAttendanceAllFeedsScreen />} />
        </Route>

        <Route
          path="/video-attendance"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={<Navigate to="/video-attendance/zones-home" replace />}
          />
        </Route>

        <Route
          path="/video-attendance/live"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LiveViewScreen />} />
        </Route>

        <Route
          path="/video-attendance/zones"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ZoneDesignerScreen />} />
        </Route>

        <Route
          path="/video-attendance/zones-home"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ZonesHomeScreen />} />
        </Route>

        <Route
          path="/camera-attendance-overstay"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<CameraAttendanceOverstayScreen />} />
        </Route>

        <Route
          path="/profile"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<Profile />} />
        </Route>

        <Route
          path="/org-chart"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<OrgChartHierarchy />} />
        </Route>

        {/* Officer Status Routes */}
        <Route
          path="/officer-status-assigned"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<Assigned />} />
        </Route>

        <Route
          path="/officer-status-not-assigned"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<NotAssigned />} />
        </Route>

        {/* Onboarding Routes */}
        <Route
          path="/onboarding-user-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<UserOnboarding />} />
        </Route>

        <Route
          path="/onboarding-bulk-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<BulkOnboarding />} />
        </Route>

        <Route
          path="/onboarding-vehicle-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<VehicleOnboarding />} />
        </Route>

        <Route
          path="/onboarding-inventory-item-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<InventoryItemOnboarding />} />
        </Route>

        <Route
          path="/inventory-manage"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ManageInventory />} />
        </Route>

        <Route
          path="/inventory-item-detail/:itemId"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<InventoryItemDetail />} />
          <Route path="logs" element={<InventoryDataLogsTable />} />
        </Route>

        <Route
          path="/inventory-item-maintenance/:itemId"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ItemMaintenance />} />
        </Route>

        <Route
          path="/inventory-return-maintenance/:itemId"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ReturnMaintenance />} />
        </Route>

        <Route
          path="/onboarding-site-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<SiteManagement />} />
          <Route path="create" element={<SiteManagement />} />
          <Route
            path="chat"
            element={
              <ChatGroupPageWrapper>
                <ChatGroupManagement />
              </ChatGroupPageWrapper>
            }
          />
          <Route
            path="chat/create"
            element={
              <ChatGroupPageWrapper>
                <CreateGroup />
              </ChatGroupPageWrapper>
            }
          />
          <Route path=":siteId/community" element={<SiteManagement />} />
        </Route>


        <Route
          path="/utility-matrix"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<UtilityMatrixDashboard />} />
        </Route>

        <Route
          path="/utility-logs"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<UtilityLogForm />} />
        </Route>

        <Route
          path="/utility-alerts"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<UtilityAlertsPanel />} />
        </Route>

        <Route
          path="/onboarding-hyper-local-referral-tracker"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<HyperLocalReferralTracker />} />
        </Route>

        <Route
          path="/onboarding-stock-in"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<StockInView />} />
          <Route path="create" element={<Stock_in />} />
        </Route>

        <Route
          path="/onboarding-close-stock"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<Closing_Stock />} />
          <Route path="view" element={<CloseStockView />} />
          <Route path="create" element={<CreateClosingStocks />} />
        </Route>

        <Route
          path="/onboarding-stock-out"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<StockOutView />} />
          <Route path="create" element={<Stock_out />} />
          <Route path="view/:id" element={<StockOutDetails />} />
          <Route path=":id" element={<StockOutDetails />} />
        </Route>

        <Route
          path="/onboarding-production"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ProductionView />} />
          <Route path="create" element={<Production />} />
        </Route>

        <Route
          path="/onboarding-product-template"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ProductTemplateView />} />
          <Route path="create" element={<ProductTemplate />} />
        </Route>

        <Route
          path="/onboarding-purchase-order"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<PurchaseOrder />} />
          <Route path="view" element={<PurchaseOrderView />} />
        </Route>

        <Route
          path="/onboarding-vender-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<VendorListView />} />
          <Route path="create" element={<VendorOnboarding />} />
        </Route>

        <Route
          path="/onboarding-stock-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<StockOnboarding />} />
        </Route>

        <Route
          path="/onboarding-bill-customer"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<BillCustomer />} />
          <Route path="view" element={<BillCustomerView />} />
        </Route>

        <Route
          path="/onboarding-create-invoice"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<CreateInvoice />} />
          <Route path="view" element={<InvoiceView />} />
        </Route>

        <Route
          path="/onboarding-create-quotation"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<EstimationQuotation />} />
          <Route path="view" element={<QuotationView />} />
        </Route>

        <Route
          path="/onboarding-interior-quotation"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<InteriorQuotation />} />
          <Route path="create" element={<CreateInteriorQuatation />} />
        </Route>

        {/* Standalone image viewer for PDF eye links — no HomePage chrome */}
        <Route
          path="/onboarding-interior-quotation/file-preview"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <QuotationFilePreview />
            </ProtectedRoute>
          }
        />

        <Route
          path="/onboarding-customer-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<CustomerListView />} />
          <Route path="create" element={<CustomerOnboarding />} />
        </Route>

        <Route
          path="/onboarding-waste-logging"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<WasteLoggingView />} />
          <Route path="create" element={<WasteLogging />} />
        </Route>

        {/* Org Management Routes */}
        <Route
          path="/org-management-device-employee-profile"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<DeleteEmployeeProfile />} />
        </Route>

        {/* <Route
          path="/org/supervisor/transfer-delete"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        > */}
        {/* <Route index element={<SupervisorTransferDelete />} />
        </Route> */}

        {/* Shift Management Routes */}
        <Route
          path="/shift-management-schedule-a-shift"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ScheduleShift />} />
        </Route>

        <Route
          path="/shift-management-schedule-a-ride"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ScheduleARide />} />
        </Route>

        <Route
          path="/shift-management-schedule-a-community-shift"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ScheduleACleaning />} />
        </Route>

        <Route
          path="/schedule-a-patrolling"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ScheduleAPatrole />} />
        </Route>

        <Route
          path="/shift-management-shift-permission-management"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ShiftPermissionManagement />} />
        </Route>

        <Route
          path="/shift-management-create-permission"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ShiftPermissionManagement />} />
        </Route>

        <Route
          path="/labor-forecast"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LaborForecastHeatmap />} />
        </Route>

        {/* Leave Management Routes */}
        <Route
          path="/leave-management/apply"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LeaveManagement defaultView="apply" />} />
        </Route>
        <Route
          path="/leave-management/manage"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LeaveManagement defaultView="requests" />} />
        </Route>
        <Route
          path="/leave-management/manage/applied"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LeaveManagement defaultView="requests" />} />
        </Route>
        <Route
          path="/leave-management/manage/history"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LeaveManagement defaultView="requests" />} />
        </Route>
        <Route
          path="/leave-management/manage/team"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LeaveManagement defaultView="requests" />} />
        </Route>
        <Route
          path="/leave-management"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LeaveManagement defaultView="apply" />} />
        </Route>
        <Route
          path="/leave-management-old"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LeaveManagement />} />
        </Route>

        {/* Service Recovery Routes */}
        <Route
          path="/service-recovery"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ServiceRecovery defaultView="alerts" />} />
        </Route>
        <Route
          path="/service-feedback"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ServiceRecovery defaultView="feedback" />} />
        </Route>
        <Route
          path="/dashboard-service-recovery-analytics"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<FeedbackAnalytics />} />
        </Route>

        {/* Tax Routes */}
        <Route
          path="/tax-overview"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<TaxOverView />} />
        </Route>
        <Route
          path="/tax-fdoc"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<Fdoc />} />
        </Route>

        {/* Reports Routes */}
        {[
          { path: '/reports/view/site', element: <SiteReports /> },
          { path: '/reports/view/employee', element: <EmployeeReport /> },
          { path: '/reports/view/ride', element: <RideReports /> },
          {
            path: '/reports/view/field-officer',
            element: <FieldOfficerReport />,
          },
          {
            path: '/reports/view/live-vehicle',
            element: <LiveVehicleReport />,
          },
        ].map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                loadingAuth={loadingAuth}
              >
                <HomePage
                  onLogout={onLogout}
                  isAuthenticated={isAuthenticated}
                />
              </ProtectedRoute>
            }
          >
            <Route index element={element} />
          </Route>
        ))}

        {/* Managing Routes */}
        <Route
          path="/managing-schedule"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ScheduleCalendar />} />
        </Route>

        <Route
          path="/lost-and-found"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<LostAndFound />} />
          <Route path="create" element={<CreateLostAndFound />} />
          <Route path=":id/edit" element={<CreateLostAndFound />} />
          <Route path=":id/collect" element={<CollectLostAndFoundItem />} />
          <Route path=":id" element={<LostAndFoundDetail />} />
        </Route>

        <Route
          path="/qr-management"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<QRManagement />} />
          <Route path="create" element={<CreateQR />} />
        </Route>

        <Route
          path="/approval-workflow"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ApprovalWorkflow />} />
        </Route>

        <Route
          path="/dues"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<CommunityDuesTable />} />
          <Route path="create" element={<CreateDue />} />
          <Route path=":dueId" element={<DueDetail />} />
        </Route>

        <Route
          path="/community-dues"
          element={<Navigate to="/dues" replace />}
        />

        <Route
          path="/projects"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ProjectsList />} />
          <Route path="create" element={<CreateProject />} />
          <Route path=":projectId/edit" element={<CreateProject />} />
          <Route path=":projectId/preview" element={<ProjectScopePreview />} />
        </Route>


        <Route
          path="/managing-facility-booking"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<FacilityBooking />} />
        </Route>

        <Route
          path="/managing-facility-booking-invoice"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<FacilityBookingInvoice />} />
        </Route>

        <Route
          path="/managing-facility-booking-bill"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<FacilityBookingBillCustomer />} />
        </Route>
        {/* Table Booking Routes */}
        <Route
          path="/table-booking"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<BookingBoard />} />
        </Route>

        <Route
          path="/table-waitlist"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<WaitlistPanel />} />
        </Route>

        <Route
          path="/table-floorplan"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<FloorPlanDesigner />} />
        </Route>

        <Route
          path="/table-onboarding"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<OnboardTable />} />
        </Route>

        {/* Cash Management Routes */}
        <Route
          path="/cash-settlement"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<SafeDropForm />} />
        </Route>

        <Route
          path="/cash-shifts"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<ShiftSettlementSummary />} />
        </Route>

        {/* Kitchen Routes */}
        <Route
          path="/place-order"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<PlaceOrderScreen />} />
        </Route>

        <Route
          path="/kitchen-order-details"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<OrderDetsilsScreen />} />
        </Route>

        <Route
          path="/kitchen-display"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              loadingAuth={loadingAuth}
            >
              <HomePage
                onLogout={onLogout}
                isAuthenticated={isAuthenticated}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<KitchenDisplayScreen />} />
        </Route>


        {/* Catch-all route for unauthenticated users */}
        {!isAuthenticated && !loadingAuth && (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </>
  );
};

export default App;
